import { COMMA, ENTER, F } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RiskControl, entitiesImpacted } from 'src/app/core/models/riskControl/riskControl';
import { riskControlDropdownDto } from 'src/app/core/models/riskControl/riskControl-filter';
import { RiskControlDto } from 'src/app/core/models/riskControl/riskControlDto';
import { riskControlService } from 'src/app/core/services/riskControl/risk-control.service';
import { MasterHelper } from 'src/app/core/utilities';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { DeleteDialogComponent } from '../distributed-ui-components';

@Component({
  selector: 'app-add-edit-risk-controls',
  templateUrl: './add-edit-risk-controls.component.html',
  styleUrls: ['./add-edit-risk-controls.component.scss'],
})
export class AddEditRiskControlsComponent implements OnInit {
  searchedAssessors: entitiesImpacted[] = [];
  riskrefList: riskControlDropdownDto[] = [];
  riskAreaList: riskControlDropdownDto[] = [];
  riskCategoryList: riskControlDropdownDto[] = [];
  riskImpact: string = '';
  entitieImpactedDD: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  risklikelihood: string = '';
  alertDialogModel: AlertDialogModel;
  riskTitleList: riskControlDropdownDto[] = [];
  copyRiskControl :RiskControl; 
  complianceTopicList: riskControlDropdownDto[] = [];
  entitiesImpactedList: riskControlDropdownDto[] = [];
  residualRiskControlStrength: riskControlDropdownDto[] = [];
  inherentRiskImpactList: riskControlDropdownDto[] = [];
  inherentRiskLikelihoodList: riskControlDropdownDto[] = [];
  riskOwnerList: riskControlDropdownDto[] = [];
  riskStatusList: riskControlDropdownDto[] = [];
  approvalStatusList: riskControlDropdownDto[] = [];
  riskAccountabilityOwnerList: riskControlDropdownDto[] = [];
  riskApproverList: riskControlDropdownDto[] = [];
  riskDescriptionList: riskControlDropdownDto[] = [];
  applicableRulesList: riskControlDropdownDto[] = [];
  isCreate!: boolean;
  showHIERARCHYANDDESCRIPTION: boolean = true;
  showOwnersANDStatus: boolean = true;
  showEntity: boolean = false;
  riskControl: RiskControl = new RiskControl(
    
  );
  showRiskScoring: boolean = false;
  showInherent: boolean = false;
  showResidual: boolean = false;
  showControl: boolean = false;
  showComments:boolean = false;
  @ViewChild('entityImpacted')
  entityImpacted!: ElementRef<HTMLInputElement>;
  @ViewChild('entitesImpactedAutoComplete')
  entitesImpactedAutoComplete!: MatAutocomplete;
  searchentitesImpactedCntrl: FormControl = new FormControl();
  @Output() RiskControl: EventEmitter<any> = new EventEmitter<any>();
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private riskcontrolService: riskControlService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AddEditRiskControlsComponent>,
  ) {
    this.isCreate = this.data.isCreate;
    this.alertDialogModel = new AlertDialogModel();
   this.copyRiskControl= new RiskControl;
   var data =  this.data;
   if(data.Data!=null){
    
    this.getRiskControlDataById(data.Data.id);
  // this.riskControl = data.Data;
   }
  }
  ngOnInit(): void {
    this.getDropwdownList();
    
  }
  getRiskControlDataById(id:number){
    
this.riskcontrolService.GetRiskControlById(id).subscribe((res)=>{
  this.riskControl = res;
  this.copyRiskControl =_.cloneDeep(this.riskControl);
 
})
  }
  getDropwdownList() {
    this.riskcontrolService.getAllDropdownList().subscribe((res) => {
      
      for (let object of res.result) {
        if (object.filterTypeId == 1) {
          this.riskAreaList.push(object);
        }
        if (object.filterTypeId == 2) {
          this.complianceTopicList.push(object);
        }
        if (object.filterTypeId == 3) {
          this.riskCategoryList.push(object);
        }
        if (object.filterTypeId == 4) {
          this.riskTitleList.push(object);
        }
        if (object.filterTypeId == 5) {
          this.riskOwnerList.push(object);
        }
        if (object.filterTypeId == 6) {
          this.riskAccountabilityOwnerList.push(object);
        }
        if (object.filterTypeId == 7) {
          this.riskApproverList.push(object);
        }
        if (object.filterTypeId == 8) {
          this.approvalStatusList.push(object);
        }
        if (object.filterTypeId == 9) {
          this.riskStatusList.push(object);
        }
        if (object.filterTypeId == 10) {
          this.entitiesImpactedList.push(object);
        }
        if (object.filterTypeId == 11) {
          this.inherentRiskLikelihoodList.push(object);
        }
        if (object.filterTypeId == 12) {
          this.inherentRiskImpactList.push(object);
        }
        if (object.filterTypeId == 13) {
          this.residualRiskControlStrength.push(object);
        }
      }

      this.riskAreaList;
      
      this.entitieImpactedDD = this.riskControl.entitiesImpacted ? this.riskControl.entitiesImpacted.split(',') : this.entitieImpactedDD;
    });
  }
  removeEntitesImpacted(status:string){
    let entitiesImpacted = [];
    entitiesImpacted = this.riskControl.entitiesImpacted ? this.riskControl.entitiesImpacted.split(',') : this.entitieImpactedDD;
    const index = (this.entitieImpactedDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.entitieImpactedDD as string[]).splice(index, 1);
     
    }
  }
  selectedEntitesImpactedEvent(event: MatAutocompleteSelectedEvent): void {
    
    if (this.entitieImpactedDD) {
      let sameValueRow = this.entitieImpactedDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.entitieImpactedDD.push(event.option.viewValue);
     
      }
    } else {
      this.entitieImpactedDD = [];
      this.entitieImpactedDD.push(event.option.viewValue);
    
    }
    if (this.entityImpacted) {
      this.entityImpacted.nativeElement.value = '';
    }
  }
  addentitesImpacted(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.entitesImpactedAutoComplete.isOpen) {
      
      event.chipInput!.clear();
      this.searchentitesImpactedCntrl.setValue(null);
    }
  }
  onRiskControl(event:any){
   if( this.riskControl.residualRiskControlStrength!=null){
    if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Strong'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Adequate'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Strong'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Adequate'){
      this.riskControl.residualRiskRating = 'Very Low'
    }
    if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
      this.riskControl.residualRiskRating = 'Low'
    }
    if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
      this.riskControl.residualRiskRating = 'Low'
    }
    if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Strong'){
      this.riskControl.residualRiskRating = 'Low'
    }
    if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
      this.riskControl.residualRiskRating = 'Low'
    }
    if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Adequate'){
      this.riskControl.residualRiskRating = 'Low'
    }
    if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
      this.riskControl.residualRiskRating = 'Moderate'
    }
    if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
      this.riskControl.residualRiskRating = 'Moderate'
    }
    if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Strong'){
      this.riskControl.residualRiskRating = 'Low'
    }
    if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
      this.riskControl.residualRiskRating = 'Moderate'
    }
    if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Adequate'){
      this.riskControl.residualRiskRating = 'Moderate'
    } if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
      this.riskControl.residualRiskRating = 'High'
    }
    if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
      this.riskControl.residualRiskRating = 'High'
    }
    if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Strong'){
      this.riskControl.residualRiskRating = 'Moderate'
    }
    if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
      this.riskControl.residualRiskRating = 'Moderate'
    }
    if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Adequate'){
      this.riskControl.residualRiskRating = 'High'
    }
    if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
      this.riskControl.residualRiskRating = 'Very High'
    }
    if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
      this.riskControl.residualRiskRating = 'Very High'
    }

    
   }
  }
 
  
  onRiskImpact(event: any) {
    this.riskImpact = event;
    if (this.risklikelihood != '' && this.riskImpact != '') {
      if (this.risklikelihood == 'Rare' && this.riskImpact == 'Insignificant') {
        this.riskControl.inherentRiskRating = 'Very Low';
      }
      if (this.risklikelihood == 'Rare' && this.riskImpact == 'Negligible') {
        this.riskControl.inherentRiskRating = 'Very Low';
      }
      if (this.risklikelihood == 'Rare' && this.riskImpact == 'Moderate') {
        this.riskControl.inherentRiskRating = 'Low';
      }
      if (this.risklikelihood == 'Rare' && this.riskImpact == 'Extensive') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (this.risklikelihood == 'Rare' && this.riskImpact == 'Significant') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (
        this.risklikelihood == 'Unlikely' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Very Low';
      }
      if (
        this.risklikelihood == 'Unlikely' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Low';
      }
      if (this.risklikelihood == 'Unlikely' && this.riskImpact == 'Moderate') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (this.risklikelihood == 'Unlikely' && this.riskImpact == 'Extensive') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (
        this.risklikelihood == 'Unlikely' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
      if (
        this.risklikelihood == 'Possible' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Low';
      }
      if (
        this.risklikelihood == 'Possible' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (this.risklikelihood == 'Possible' && this.riskImpact == 'Moderate') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (this.risklikelihood == 'Possible' && this.riskImpact == 'Extensive') {
        this.riskControl.inherentRiskRating = 'High';
      }
      if (
        this.risklikelihood == 'Possible' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
      if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Moderate'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
      if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Extensive'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
      if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'Very High';
      }
      if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
      if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Moderate'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
      if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Extensive'
      ) {
        this.riskControl.inherentRiskRating = 'Very High';
      }
      if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'Very High';
      }
    }
    if( this.riskControl.residualRiskControlStrength!=null){
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Moderate'
      } if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'High'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'High'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'High'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Very High'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Very High'
      }
  
      
     }

  }
  closeAction() {
    
    const areEqual = _.isEqual(this.riskControl, this.copyRiskControl);
    if(areEqual){
      this.dialogRef.close({ object: [], edited: false });
    }
    else{
this.openCancelDialog();
    }
  }
  openCancelDialog(): void {
    this.alertDialogModel.HeadingText = 'Cancel';
    this.alertDialogModel.BodyText = 'Are you sure you want to cancel this?';
    this.alertDialogModel.ActionButtonText = 'Ok';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result) => {
            if (result === 'Cancel') {
      
        this.dialogRef.close({ object: [], edited: false });
      }
    });
  }
  onRiskLikelihood(event: any) {
    
  //  var data =  event.replace(/\s+/g, '')
  //  var checkrisklikelihood = this.risklikelihood;
  //  var checkriskimpact = this.riskImpact;
    this.risklikelihood = event;
    if (this.risklikelihood != '' && this.riskImpact != '') {
      if (this.risklikelihood == 'Rare' && this.riskImpact == 'Insignificant') {
        this.riskControl.inherentRiskRating = 'Very Low';
        
      }
     if (this.risklikelihood == 'Rare' && this.riskImpact == 'Negligible') {
        this.riskControl.inherentRiskRating = 'Very Low';
      }
     if (this.risklikelihood == 'Rare' && this.riskImpact == 'Moderate') {
        this.riskControl.inherentRiskRating = 'Low';
      }
     if (this.risklikelihood == 'Rare' && this.riskImpact == 'Extensive') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (this.risklikelihood == 'Rare' && this.riskImpact == 'Significant') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (
        this.risklikelihood == 'Unlikely' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Very Low';
      }
    if (
        this.risklikelihood == 'Unlikely' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Low';
      }
     if (this.risklikelihood == 'Unlikely' && this.riskImpact == 'Moderate') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (this.risklikelihood == 'Unlikely' && this.riskImpact == 'Extensive') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (
        this.risklikelihood == 'Unlikely' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
     if (
        this.risklikelihood == 'Possible' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Low';
      }
     if (
        this.risklikelihood == 'Possible' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
    if (this.risklikelihood == 'Possible' && this.riskImpact == 'Moderate') {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (this.risklikelihood == 'Possible' && this.riskImpact == 'Extensive') {
        this.riskControl.inherentRiskRating = 'High';
      }
     if (
        this.risklikelihood == 'Possible' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
     if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Moderate'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
    if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Extensive'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
     if (
        this.risklikelihood == 'Likely' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'Very High';
      }
    if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Insignificant'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
    if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Negligible'
      ) {
        this.riskControl.inherentRiskRating = 'Moderate';
      }
     if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Moderate'
      ) {
        this.riskControl.inherentRiskRating = 'High';
      }
     if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Extensive'
      ) {
        this.riskControl.inherentRiskRating = 'Very High';
      }
     if (
        this.risklikelihood == 'Almost Certain' &&
        this.riskImpact == 'Significant'
      ) {
        this.riskControl.inherentRiskRating = 'Very High';
      }
    }
    if( this.riskControl.residualRiskControlStrength!=null){
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Very Low' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Very Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Low' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'Moderate' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Low'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'Moderate'
      } if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'High'
      }
      if(this.riskControl.inherentRiskRating == 'High' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'High'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Strong'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Reasonably Strong'){
        this.riskControl.residualRiskRating = 'Moderate'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Adequate'){
        this.riskControl.residualRiskRating = 'High'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Marginally Adequate'){
        this.riskControl.residualRiskRating = 'Very High'
      }
      if(this.riskControl.inherentRiskRating == 'Very High' && this.riskControl.residualRiskControlStrength=='Weak or Non-Existent'){
        this.riskControl.residualRiskRating = 'Very High'
      }
  
      
     }
  }
  removeentitiesImpactedList(id: string) {
    if (this.entitiesImpactedList && this.entitiesImpactedList.length > 0) {
      const index = this.entitiesImpactedList.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.entitiesImpactedList.splice(index, 1);
      }
      // this.filterriskAreaWithoutSelectedItem();
    }
  }
  
  openOwnersANDStatus() {
    this.showOwnersANDStatus = true;
    this.showHIERARCHYANDDESCRIPTION = false;
    this.showControl = false;
    this.showComments =false;
    this.showEntity = false;
    this.showInherent = false;
    this.showRiskScoring = false;
    this.showResidual = false;
  }
  OpenControl() {
    this.showControl = true;
    this.showComments =false;
    this.showHIERARCHYANDDESCRIPTION = false;
    this.showOwnersANDStatus = false;
    this.showEntity = false;
    this.showInherent = false;
    this.showRiskScoring = false;
    this.showResidual = false;
  }
  
  OpenshowRiskScoring() {
    this.showRiskScoring = true;
    this.showInherent = false;
    this.showResidual = false;
    this.showComments =false;
    this.showControl = false;
    this.showHIERARCHYANDDESCRIPTION = false;
    this.showOwnersANDStatus = false;
    this.showEntity = false;
  }
 
  openComments(){
    this.showComments = true;
    this.showEntity = false;
    this.showRiskScoring = false;
    this.showInherent = false;
    this.showResidual = false;
    
    this.showControl =false;
    this.showHIERARCHYANDDESCRIPTION = false;
    this.showOwnersANDStatus = false;
  }
  updateRiskControl(){
    
    
    this.riskControl.dateCreated = this.riskControl.dateCreated ?
    MasterHelper.bsdatePickerToCorrectDate(this.riskControl.dateCreated.toString()) : null;
    this.riskControl.effectiveDate = this.riskControl.effectiveDate ?
    MasterHelper.bsdatePickerToCorrectDate(this.riskControl.effectiveDate.toString()) : null;
    this.riskControl.lastEdited = this.riskControl.lastEdited ?
    MasterHelper.bsdatePickerToCorrectDate(this.riskControl.lastEdited.toString()) : null;
    if(this.entitieImpactedDD!=null)
{
  this.riskControl.entitiesImpacted = this.entitieImpactedDD.toString();
}   

if(this.riskControl.id!=0){
  
    const areEqual = _.isEqual(this.riskControl, this.copyRiskControl);
    if( areEqual){
     this.dialogRef.close({ object: [], edited: false });
    }
    else{
     this.riskcontrolService.AddRiskControl(this.riskControl).subscribe((result=>{
       this.dialogRef.close({ object: [], edited: true });
     }));
    
   }
  
}
else{
  const areEqual = _.isEqual(this.riskControl, this.copyRiskControl);
    if( areEqual){
     this.dialogRef.close({ object: [], edited: false });
    }
    else{
     this.riskcontrolService.AddRiskControl(this.riskControl).subscribe((result=>{
       this.dialogRef.close({ object: [], edited: true });
     }));
    
   }
}
  
   
  }
}
